import { useQuery, useMutation } from "@tanstack/react-query";
import { adverseEventApiService } from "./adverseevent.api";
import { AdverseEvent } from "../helper/adverseevent.types";

export const useAdverseEventApi = (params?: any) => {
  // Selectall Query
  const SelectAllQuery = useQuery({
    queryKey: ["adverse-event-select-all", params],
    queryFn: () => adverseEventApiService.getSelectAll(params),
    enabled:
      !!params?.pagesize &&
      !!params?.pagenumber &&
      !!params?.status ,
  });

  const SelectByIdQuery = useQuery({
    queryKey: ["adverse-event-select-by-id", params],
    queryFn: () => adverseEventApiService.getSelectById(params),
    enabled: !!params?.adverseeventid,
  });

  // Full Add AE Mutation
  const InsertMutation = useMutation({
    mutationFn: (data: Partial<AdverseEvent>) =>
      adverseEventApiService.insertData(data),
  });

  // Full delete AE Mutation
  const DeleteMutation = useMutation({
    mutationFn: (data: Partial<AdverseEvent>) =>
      adverseEventApiService.deleteData(data),
  });

  // Full update AE Mutation
  const UpdateMutation = useMutation({
    mutationFn: (data: Partial<AdverseEvent>) =>
      adverseEventApiService.updateData(data),
  });

  const VerifyMutation = useMutation({
    mutationFn: (data: any) =>
      adverseEventApiService.verifyData(data),
  });

  return {
    SelectAllQuery,
    InsertMutation,
    DeleteMutation,
    SelectByIdQuery,
    UpdateMutation,
    VerifyMutation,
  };
};
